import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormWrapper } from 'components/Page';
import { DatePicker, Form } from 'antd';
import ExtendedSelect from 'components/extendedSelect/extended-select';
import settings from 'settings';
import { getKey, getLabel } from 'library/helpers';
import { list } from 'actions';
import REDUCER_KEY from 'reducers/reducer.keys';

const FormItem = Form.Item;

const mapStateToProps = state => ({
  validations: state.api.validations.data.results,
  validationsInFlight: state.api.validations.inFlight
});

const mapDispatchToProps = dispatch => ({
  loadValidations(searchText) {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'id',
      desc: true
    }];
    const filters = [];

    if (!searchText) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }
    dispatch(list(REDUCER_KEY.validations.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, form, inputFormItemLayout, loadValidations, validations, validationsInFlight, visibleTimeStart, visibleTimeEnd
}) => {
  const { getFieldDecorator } = form;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Validations">
        {getFieldDecorator('validations', {
          rules: [
            {
              required: true,
              message: 'Please select a requestor.'
            }
          ]
        })(
          <ExtendedSelect
            fetching={validationsInFlight}
            placeholder="Select validation"
            optionKey={getKey}
            optionLabel={getLabel}
            disabled={!canAdmin}
            onSearch={loadValidations}
            onFocus={loadValidations}
            dataSource={validations}
          />
        )}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Start">
        {getFieldDecorator('start', {
          initialValue: [visibleTimeStart, visibleTimeEnd]
        })(
          <DatePicker.RangePicker
            allowClear={false}
            format="DD-MM-YYYY H:mm"
            size="small"
            showTime={{ format: 'HH:mm' }}
          />
        )}
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  loadValidations: PropTypes.func,
  validations: PropTypes.array,
  validationsInFlight: PropTypes.bool,
  visibleTimeStart: PropTypes.object.isRequired,
  visibleTimeEnd: PropTypes.object.isRequired
};

FormInput.defaultProps = {
  canAdmin: false,
  form: {},
  inputFormItemLayout: {},
  loadValidations() {
  },
  validations: [],
  validationsInFlight: false
};

const ValidationInput = FormWrapper(Form.create({
  onFieldsChange,
  onValuesChange
})(FormInput));

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(ValidationInput);
